export default function offcanvas() {
	let triggers = document.querySelectorAll('a[data-offcanvas]');

	const handleOffcanvasToggle = (e) => {
		e.preventDefault();

		let target_id        = e.currentTarget.dataset.offcanvas;
		let target           = document.getElementById( target_id );
		let global_indicator = 'offcanvas-open';
		let open_indicator   = `${target_id}-open`;

		if ( target ) {
			document.body.classList.toggle(open_indicator);
			document.body.classList.toggle(global_indicator);

			if ( document.body.classList.contains(open_indicator) ) {
				target.style.transform = 'translateX(0)';
			} else {
				// remove inline transform style
				target.style.transform = '';
			}
		}
	};

	if ( triggers.length ) {
		triggers.forEach(trigger => {
			trigger.addEventListener('click', handleOffcanvasToggle);
		});
	}
}